module.exports = __webpack_public_path__ + "img/gs.175a61d.svg";